import { useState, useRef, useCallback, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton as MuiIconButton,
  Button
} from '@mui/material'
import { Close, CloudUpload } from '@mui/icons-material'
import styled from 'styled-components'
import { useCheckFactura } from 'api'
import { setPurchaseReceiptAttributes } from 'slices/purchaseReceiptSlice'
import { useDispatch } from 'react-redux'
import { toast } from 'react-hot-toast'
import { useParams } from 'react-router-dom'

function FacturaCheckModal({ open, onClose, purchaseId }) {
  const [selectedFile, setSelectedFile] = useState(null)
  const [state, setState] = useState({
    XMLfileUpload: '',
    XMLData: [],
    XmlBolenResult: '',
    factura_total_field: {},
    factura_total_chekbox: {
      tax: false,
      total_purchase: false
    },
    factura_line_item: {},
    initialCheckboxData: []
  })
  const fileInputRef = useRef(null)
  const dispatch = useDispatch()
  const { id } = useParams()
  const {
    isCheckFacturaDataLoading,
    handleGetFacturaPopDetails,
    handleProcessFacturaFile
  } = useCheckFactura()

  const handleCloseModal = () => {
    onClose()
    setSelectedFile(null)
  }

  const onMatchNumbers = data => {
    
  }

  const onUndoMatchNumbers = data => {
    
  }
  const onCheckAll = data => {
    
  }
  const onUncheckAll = data => {
  
  }

  const onLineItemCheckbox = () => {}

  const onTotalsCheckbox = () => {}

  const onReject = () => {}

  const onApprove = () => {}

  const XMLfileUpload = event => {
    setSelectedFile(null)
    setState({
      XMLfileUpload: '',
      XMLData: [],
      XmlBolenResult: '',

      factura_total_field: {},
      factura_total_chekbox: {
        tax: false,
        total_purchase: false
      },
      factura_line_item: {},
      initialCheckboxData: []
    })

    const file = event.target.files[0]
    if (file) {
      setSelectedFile(file)
      setState({
        ...state,
        XMLfileUpload: file
      })
    }
    dispatch(
      setPurchaseReceiptAttributes({
        pr_no: purchaseId,
        attributes: { is_factura_overrided: '0' }
      })
    )
  }

  const getBase64XML = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve({ base64: reader.result, file_obj: file })
      reader.onerror = error => reject(error)
    })
  }

  const facturaFile = async () => {
    let file = state.XMLfileUpload
    if (file) {
      const filePathsPromises = []
      filePathsPromises.push(getBase64XML(file))
      const filePaths = await Promise.all(filePathsPromises)

      let payload = {
        purchase_request_id: purchaseId,
        customer_id: id,
        file: filePaths[0].base64,
        file_name: filePaths[0].file_obj.name
      }
      let factura_result = await handleProcessFacturaFile(payload)
      setState({ XmlBolenResult: factura_result.success })
      setState({
        XMLData: [factura_result]
      })
    } else {
      toast.error('please select a file')
    }
  }

  const handleProcessFactura = useCallback(async () => {
    if (!purchaseId) {
      return
    }

    try {
      const formData = new FormData()
      formData.append('purchase_request_id', purchaseId)

      await handleGetFacturaPopDetails(formData)
    } catch (error) {
      console.error('Error processing factura:', error)
    }
  }, [purchaseId, handleGetFacturaPopDetails])

  useEffect(() => {
    if (open && purchaseId) {
      handleProcessFactura()
    }
  }, [open])

  const openFileDialog = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleCloseModal}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
            minHeight: '400px',
            position: 'relative'
          }
        }
      }}
    >
      <DialogTitle
        sx={{
          background: '#F6C44B',
          color: '#000',
          fontWeight: 'bold',
          fontSize: '1.2rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        Upload Factura File
        <MuiIconButton onClick={handleCloseModal} sx={{ color: '#000' }}>
          <Close />
        </MuiIconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4,
          px: 3,
          cursor: 'default'
        }}
      >
        <UploadZone onClick={openFileDialog}>
          <CloudUpload sx={{ fontSize: '4rem', color: '#8B7355', mb: 2 }} />
          <Typography variant="h6" color="textPrimary">
            Upload Factura File
          </Typography>
        </UploadZone>

        <input
          ref={fileInputRef}
          type="file"
          style={{ display: 'none' }}
          onChange={XMLfileUpload}
          accept=".xml"
        />

        {selectedFile && (
          <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
            Selected: {selectedFile.name}
          </Typography>
        )}
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'center',
          pb: 3
        }}
      >
        <Button
          onClick={facturaFile}
          disabled={!selectedFile || isCheckFacturaDataLoading}
          variant="outlined"
          sx={{
            backgroundColor: '#E5E5E5',
            color: '#333',
            borderColor: '#ccc',
            '&:hover': {
              backgroundColor: '#d5d5d5',
              borderColor: '#999'
            }
          }}
        >
          {isCheckFacturaDataLoading ? 'Processing...' : 'Process Factura'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const UploadZone = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s ease;

  &:hover {
    border-color: #8b7355;
  }
`

export default FacturaCheckModal
